module.exports = __webpack_public_path__ + "static/media/Taylor-Co-Founder.365968be.png";